import App from '@/App.vue'
import axios from 'axios'
import { routes } from '@/routes'
import { ServerTable, ClientTable, Event } from 'vue-tables-2'
import VuejsDialog from "vuejs-dialog"
import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import Auth from "@okta/okta-vue";
import { LoginCallback } from '@okta/okta-vue'
import { OktaAuth } from '@okta/okta-auth-js'
import _ from 'lodash'
import '@okta/okta-signin-widget/dist/css/okta-sign-in.min.css'


const securityProfiles = process.env.SECURITY_PROFILE.split(",")

localStorage.setItem("active_profiles",process.env.SECURITY_PROFILE)


Vue.use(VueRouter)

if(securityProfiles.includes('security-okta')){
    const oktaAuth = new OktaAuth({  
        issuer: process.env.OKTA_ISSUER,
        clientId: process.env.OKTA_CLIENT_ID
    })
    Vue.use(Auth, { oktaAuth })
}


export var axiosRequests =  axios.create({
    baseURL: process.env.BASE_URL + '/api/' + process.env.API_VERSION,
    headers: {
        authorization: localStorage.getItem("token")
    }
})

//Axios Request Interceptor - To fetch token on log on when auth user flow takes longer to resolve - after home page loads up
axiosRequests.interceptors.request.use(async function (config) {
    // If token is missing - fetch it
    var currentAuth = config.headers.authorization
    
    if(securityProfiles.includes('security-okta') && (String(currentAuth)=='null' || currentAuth==undefined)) {
        console.log(`securityProfile::security-okta`)
        var aut = await Vue.prototype.$auth.isAuthenticated()
        console.log(`RGD ${JSON.stringify(aut)}`)
        var newToken = await fetchToken()
        var claims = await fetchUser(newToken.accessToken)
        getOktaTokenAndExpiryDate(); 
        config.headers.authorization = 'Bearer ' + newToken.accessToken.value
        await store.dispatch('loginFromOktaToken', {'token': newToken.accessToken.value, 'claims': claims})
    }
    
    return config;

  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

// Axios Response Interceptor - Log Out on 401
axiosRequests.interceptors.response.use(function (response) {
    return response
  }, 
  function (error) {
    
    console.log(error.response.data)
    
    if (error.response.status === 401) {
        console.log("Expired Token. Logging user out...")
        getOktaTokenAndExpiryDate(); 
        store.dispatch('logout')
    }
    return Promise.reject(error)
})

function verifyToken(token, page) {
    return axiosRequests.get("/", {
        headers: {
            authorization: token,
            page: page
        }
    })
}


//TODO: If more of these are need -- we might need a helpers directory
export function parseUserFromToken(token){
    let payload = token.split(".")[1]
    let parsedPayload = JSON.parse(atob(payload))
    let roles = []
    let privileges = []

    //TODO: maybe deal with the clientId: 0 aspect a bit more?
    parsedPayload.authorities.forEach(auth =>{
        if(auth.includes("ROLE_")){
            roles.push(auth)
        }else{
            privileges.push(auth)
        }
    })
    let user = {
        userId: parsedPayload.sub,
        username: parsedPayload.username,
        roles,
        privileges
    }
    return user
}

export function parseUserFromOktaToken(payload){
    let user = {
        username: payload.claims.name,
        client_NAMES: payload.claims.client_NAMES
    }
    return user
}

Vue.use(VuejsDialog, {html:true})
Vue.use(Vuex)
Vue.use(ServerTable, [
    {
        texts: {
            filter: "Search:"
        },
        datepickerOptions: {
            showDropdowns: true
        }
    }
])
Vue.use(ClientTable, [
    {
        texts: {
            filter: "Search:"
        },
        datepickerOptions: {
            showDropdowns: true
        }
    }
])

const router = new VueRouter({
    mode: 'history',
    routes: [
        { path: '/implicit', component: LoginCallback },
        ...routes
      ],
    // routes,
    scrollBehavior() {
      return {x: 0, y: 0}
    }
})

async function fetchToken(){
    var aut = await Vue.prototype.$auth.isAuthenticated()
    console.log(`RGD ${JSON.stringify(aut)}`)
    var token = await Vue.prototype.$auth.tokenManager.getTokens()
    return token
}

async function fetchUser(token){
    var claims = await Vue.prototype.$auth.getUser(token)
    console.log(`RGD claims=${JSON.stringify(claims)}`)
    return claims
}

async function getOktaTokenAndExpiryDate() {
  try {

    const stored_tok = localStorage.getItem("token")
    console.log(`RGD ${JSON.stringify(stored_tok)}`)

    const token = fetchToken()
    const accessToken = fetchUser()

    if (!accessToken) {
      console.warn("No access token found. User might not be authenticated.");
      return null;
    }

    console.log(`RGD accessToken:${JSON.stringify(accessToken)}`)
    console.log(`RGD token:${JSON.stringify(token)}`)

    const expiryTimestamp = accessToken.exp;

    if (!expiryTimestamp) {
      console.warn("Access token does not contain an 'exp' claim.");
      return null;
    }

    const expiryDate = new Date(expiryTimestamp * 1000);

    console.log('RGD Okta Access Token:', accessToken);
    console.log('RGD Okta Access Token Expiry Date:', expiryDate);

    const currentDate = new Date();
    console.log(`RGD currentDate: ${currentDate}`);

    return {
      accessToken: accessToken,
      expiryDate: expiryDate,
    };

  } catch (error) {
    console.error('RGD Error in getOktaTokenAndExpiryDate:', error);
    return null;
  }
}

const vuexLocalStorage = new VuexPersist({
    key: 'vuex', 
    storage: window.localStorage
  })

//TODO: Extract store to its own directory, and state, mutations, and actions to sub directories
const store = new Vuex.Store({
    state: {
        user: null,
        baseURL: process.env.BASE_URL,
        systemMessage: ""
    },
    getters: {
        isAdmin(state){
            try{
                return state.user.roles.includes("ROLE_ADMIN")
            }catch(err){
                return false
            }
        },
        isLoggedIn(state){
            return !!state.user
        }
    },
    mutations: {
        setUser(state, payload){
            state.user = payload.user
        },
        setToken(state, token){
            axiosRequests.defaults.headers.authorization = "Bearer " + token
            localStorage.token = "Bearer " + token
        },
        setTokenWithoutBearer(state, token){
            axiosRequests.defaults.headers.authorization =  token
            localStorage.token = token
        },
        setSystemMessage(state, payload){
            state.systemMessage = payload.message
        },
        resetState(state, payload){
            //TODO: Could alternatively wipe out entire local storage
            state.user = null
            state.systemMessage = ""
            localStorage.removeItem('token');
            axiosRequests.defaults.headers.authorization = null
        }
    },
    actions: {
        async logout({commit, dispatch}){
            commit('resetState')
            if(securityProfiles.includes('security-okta')){
                //Method causin endless redirect - sign out URL on Okta portal for app not setting - must reaise issue with Okta
                // await Vue.prototype.$auth.signOut() // RGD:
            }
            router.push("/login")
        },
        loginFromTokenWithoutBearer({commit, dispatch}, payload){
            const user = parseUserFromToken(payload.token)
            const token = payload.token
            commit('setTokenWithoutBearer',  token )
            commit('setUser', { user })
        },
        loginFromToken({commit, dispatch}, payload){
            const user = parseUserFromToken(payload.token)
            const token = payload.token
            commit('setToken',  token )
            commit('setUser', { user })
        },
        loginFromOktaToken({commit, dispatch}, payload){
            const user = parseUserFromOktaToken(payload)
            const token = payload.token
            commit('setToken',  token )
            commit('setUser', { user })
        },
        setSystemMessage({commit}, payload){
            commit('setSystemMessage', payload)
        },
        loginFromForm({commit}, payload){
            //using axios.post directly since login route is different namespace from API
            axios.post(`${process.env.BASE_URL}/login`, {data: payload})
            .then(resp => {
                const token = resp.headers.authorization
                // We need to modify the API axios instance to send the new token with the requests
                const user = parseUserFromToken(token)
                axiosRequests.defaults.headers.authorization = token
                localStorage.setItem("token", token)
                commit('setUser',{ user })
                router.push("/")
            })
            .catch(err=>{
                if(err.response && err.response.status === 403){
                   commit(
                       'setSystemMessage',
                       { message: "Unable to verify credentials, please check credentials and try again" }
                    )
                } else {
                    commit(
                        'setSystemMessage',
                        { message: "Something went wrong, please try again in a few minutes" }
                    )
                }
            })
        }
    },
    plugins: [vuexLocalStorage.plugin]
})


const securityDbAuthGuard = ((to, from, next) => {
    let token = localStorage.getItem('token')
    let page = to['name']
    //Have to catch case when token is deleted/expired, but user tries to continue interaction with the app
    verifyToken(token,page).catch((e)=>{
        console.log(e)
        store.dispatch('logout')
    })
    if(to.path != '/login') {
        if(store.getters.isLoggedIn) {
            //There is a user, parse and resume.
            if (to.matched.some(record => record.meta.requiresAdmin)) {
                // if this route requires Admin, check if Admin
                // if not, redirect to forbidden.
                if (!store.getters.isAdmin) {
                    next({
                    path: '/forbidden',
                    query: { redirect: to.fullPath }
                    })
                } else {
                    //if Admin, proceed
                    if(to.path !== 'login'){
                        //If user exists and route is login, redirect to home
                        next()
                    } else {
                        //otherwise, proceed
                        next('/')
                    }
                }
            } else {
                // Route doesn't require admin, proceed

                if(to.path !== 'login'){
                    //If user exists and route is login, redirect to home
                    next()
                } else {
                    //otherwise, proceed
                    next('/')
                }
            }
        } else {
            //There is no user, redirect to login.
            next('login');
        }
    } else {

        if(store.getters.isLoggedIn){
            // if user present, redirect away from login
            next('/')
        } else {
            // if no user no need to redirect, already on login route
            next();
        }
    }
})


const oktaAuthGuard = async (to, from, next) => {
    var isAuthenticated = await Vue.prototype.$auth.isAuthenticated()
    
    if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
        store.dispatch('logout')
    }
    else {
        next()
    }
}

//Check Authentication before Navigating away from routes based on auth profile
const checkAuthentication = ((to, from, next) => {
    if(securityProfiles.includes('security-okta')){
        oktaAuthGuard(to, from, next)
    } 
    else if(securityProfiles.includes('security-db')){
        securityDbAuthGuard(to, from, next)
    }
    else{
        next()
    }
})
  
router.beforeEach(checkAuthentication)

// import VueSimpleContextMenu from 'vue-simple-context-menu';
// Vue.component("vue-simple-context-menu",VueSimpleContextMenu)

new Vue({
    el: '#app',
    router,
    store: store,
    render: h => h(App)
})


